import { StyleSheet } from 'aphrodite'

import main from './main'
import headers from './headers'
import paragraphs from './paragraphs'
import date from './date'
import info from './info'

export default {
  main: StyleSheet.create(main),
  headers: StyleSheet.create(headers),
  paragraphs: StyleSheet.create(paragraphs),
  date: StyleSheet.create(date),
  info: StyleSheet.create(info)
}



// WEBPACK FOOTER //
// ./src/components/News/partials/SingleArticle/style/index.js